import React, { FC, useContext, useEffect } from 'react';
import { BigLineSeparator } from '../../../components/separator/LineSeparator';
import { LawFirmHeaderInfos } from './LawFirmHeaderInfos';
import { EntityCardHeader } from '../../../entity/components/EntityCardComponents';
import { PageNavContext } from '../../../components/page-nav/PageNavContext';
import { LawFirmHeaderTop } from './LawFirmHeaderTop';

type Props = {
  nbLawyers: number;
};

export const LawFirmHeader: FC<Props> = ({ nbLawyers }) => {
  const id = 'law-firm-header';
  const { createNav } = useContext(PageNavContext);

  useEffect(() => {
    createNav(id);
  }, []);

  return (
    <EntityCardHeader id={id}>
      <LawFirmHeaderTop />
      <BigLineSeparator />
      <LawFirmHeaderInfos nbLawyers={nbLawyers} />
    </EntityCardHeader>
  );
};
